import React from 'react';
import PropTypes from 'prop-types';

import { uniqBy } from '../../../util';

const getDisplayMultiplierFromImage = (image) => {
    if (image.device.includes('2x')) { return '2x'; }
    return '';
};

const mapUrlToSrcset = image => (`${image.url} ${getDisplayMultiplierFromImage(image)}, `);

const getSrcset = (images) => {
    let srcsetString = '';

    images.forEach((image) => {
        srcsetString += mapUrlToSrcset(image);
    });
    srcsetString = srcsetString.substring(0, srcsetString.length - 2);

    return srcsetString;
};

const removeDuplicateImages = images => uniqBy(images, 'device');

const getImagesPerDevice = (images, device) => images.filter(image => image.device.includes(device));

const Source = ({ images, mediaQuery }) => {
    const uniqueImages = removeDuplicateImages(images);
    const deviceImages = getImagesPerDevice(uniqueImages, mediaQuery.device);
    const srcSet = getSrcset(deviceImages);

    return (
        <source
            srcSet={ srcSet }
            media={ `(min-width: ${mediaQuery.minWidth})` }
        />
    );
};

Source.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string,
            device: PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
        })
    ),
    mediaQuery: PropTypes.shape({
        device: PropTypes.string,
        minWidth: PropTypes.string,
    }),
};

Source.defaultProps = {
    images: [],
    mediaQuery: {},
};

export default Source;
